﻿module SafeStack.Client.HTMLIdentifier
open System.Text.RegularExpressions

[<Literal>]
let private PATTERN = @"^[A-z][\w\-\.]*$"

type HTMLIdentifier = private HTMLIdentifier of string

module HTMLIdentifier =
    let tryOfString (str: string) =
        if Regex.IsMatch (str, PATTERN) then
            HTMLIdentifier str |> Ok
        else
            sprintf "%s is not a valid HTML identifier" str |> Error

    /// This will fail if the provided ID string is invalid
    let ofStringOrFail =
        tryOfString >> Result.defaultWith failwith

    let toString =
        function HTMLIdentifier s -> s